import { useState } from 'react'
import { Workspace } from 'types'
import { HeapEventType, trackEventInHeap } from 'utils/heapTracking'
import InviteByEmail from './InviteByEmail'
import ImportEmails from './ImportEmails'
import Styles from './InviteTeam.module.scss'
import { InviteByLink } from './InviteByLink'
import { useCurrentPlan } from 'hooks/useCurrentPlan'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { MobileHeader } from './components/MobileHeader/MobileHeader'
import { useTierUsageLimits } from 'hooks/useTierUsageLimits'
import { Modal } from 'almanac-ui/Modal'
import { SegmentedControl } from 'blaze-ui/SegmentedControl/SegmentedControl'
import { Item } from 'components/Menu/MenuItem'

export type Tab = 'email' | 'link'

interface InviteTeamProps {
  onClose: () => void
  workspace: Workspace
}

const InviteTeam = ({ onClose, workspace }: InviteTeamProps) => {
  const [showImport, setShowImport] = useState(false)
  const [currentTab, setCurrentTab] = useState<Tab>('email')
  const { data: currentPlan } = useCurrentPlan()

  const showImportScreen = () => {
    setShowImport(true)
    trackEventInHeap(HeapEventType.ImportContacts, { action: 'google_contact_import_started', type: '' })
  }
  const { atLimit, nextTierPlan, currentTierPlan } = useTierUsageLimits({
    limitKey: 'seats',
  })

  const shouldEnforceSeatLimit = atLimit && nextTierPlan && currentTierPlan

  return (
    <>
      <ResponsiveDesign.Mobile>
        <MobileHeader currentTab={currentTab} setCurrentTab={setCurrentTab} />
        <div className={Styles.mobileContentContainer}>
          {currentTab === 'email' && <InviteByEmail onClose={onClose} workspace={workspace} />}
          {currentTab === 'link' && showImport && (
            <ImportEmails onClose={onClose} setShowImport={setShowImport} workspace={workspace} />
          )}
          {currentTab === 'link' && !showImport && currentPlan && (
            <InviteByLink showImportScreen={showImportScreen} currentPlan={currentPlan} onClose={onClose} />
          )}
        </div>
      </ResponsiveDesign.Mobile>
      <ResponsiveDesign.Desktop>
        <Modal.Header
          title="Invite Your Team"
          actions={
            <SegmentedControl
              activeItem={currentTab}
              isDisabled={!!shouldEnforceSeatLimit}
              onItemClick={(newValue) => {
                if (currentTab === newValue) {
                  return
                }
                setCurrentTab(newValue as Tab)
              }}
            >
              <Item key="email">Invite by Email</Item>
              <Item key="link">Invite by Link</Item>
            </SegmentedControl>
          }
        />
        <div className={Styles.tabContentArea}>
          {currentTab === 'email' && <InviteByEmail onClose={onClose} workspace={workspace} />}
          {currentTab === 'link' && showImport && (
            <ImportEmails onClose={onClose} setShowImport={setShowImport} workspace={workspace} />
          )}
          {currentTab === 'link' && !showImport && currentPlan && (
            <InviteByLink showImportScreen={showImportScreen} currentPlan={currentPlan} onClose={onClose} />
          )}
        </div>
      </ResponsiveDesign.Desktop>
    </>
  )
}

export default InviteTeam
